import * as T from './loyaltyNotificationsTypes';
import type { UpdateNotificationPayload } from '../../../services/loyaltyProgramApi';

export const fetchNotificationConfigsRequest = () => ({
  type: T.FETCH_NOTIFICATION_CONFIGS_REQUEST as typeof T.FETCH_NOTIFICATION_CONFIGS_REQUEST,
});

export const fetchNotificationConfigsSuccess = (data: any[]) => ({
  type: T.FETCH_NOTIFICATION_CONFIGS_SUCCESS as typeof T.FETCH_NOTIFICATION_CONFIGS_SUCCESS,
  payload: data,
});

export const fetchNotificationConfigsFailure = (error: string) => ({
  type: T.FETCH_NOTIFICATION_CONFIGS_FAILURE as typeof T.FETCH_NOTIFICATION_CONFIGS_FAILURE,
  payload: error,
});

export const updateNotificationConfigRequest = (configId: string, payload: UpdateNotificationPayload) => ({
  type: T.UPDATE_NOTIFICATION_CONFIG_REQUEST as typeof T.UPDATE_NOTIFICATION_CONFIG_REQUEST,
  payload: { configId, data: payload },
});

export const updateNotificationConfigSuccess = (data: any) => ({
  type: T.UPDATE_NOTIFICATION_CONFIG_SUCCESS as typeof T.UPDATE_NOTIFICATION_CONFIG_SUCCESS,
  payload: data,
});

export const updateNotificationConfigFailure = (error: string) => ({
  type: T.UPDATE_NOTIFICATION_CONFIG_FAILURE as typeof T.UPDATE_NOTIFICATION_CONFIG_FAILURE,
  payload: error,
});

export type LoyaltyNotificationsAction =
  | ReturnType<typeof fetchNotificationConfigsRequest>
  | ReturnType<typeof fetchNotificationConfigsSuccess>
  | ReturnType<typeof fetchNotificationConfigsFailure>
  | ReturnType<typeof updateNotificationConfigRequest>
  | ReturnType<typeof updateNotificationConfigSuccess>
  | ReturnType<typeof updateNotificationConfigFailure>;
